import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { ILanguage, IVersion } from "../../../models/Interfaces";
import AddPageDialogue, { IAddPageDialogueRef } from "./AddPageDialogue";
import { AddUpdatePageCommand } from "../../../models/content/AddUpdatePageCommand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

export interface IClonePageRef {
  getPage: () => Promise<AddUpdatePageCommand | null>;
}

interface IClonePageDialogue {
  Languages: Array<ILanguage>;
  SourceVersion: IVersion;
  SourcePageLanguage?: string | null;
  SourcePageAlias?: string | null;
  samePageCallback: (versionid: number) => void;
  newPageCallback: (page: AddUpdatePageCommand) => void;
  cancelCallback: () => void;
}

const ClonePageDialogue = forwardRef((props: IClonePageDialogue, ref) => {
  const [newPage, setNewPage] = useState<boolean>(false);

  const addPageRef = useRef<IAddPageDialogueRef>(null);

  const cloneNewPage = () : void => {
    setNewPage(true);
  };

  const cloneSamePage = () : void => {
    if (props.samePageCallback) {
      props.samePageCallback(props.SourceVersion.Id);
    }
  };

  const handleCloneNewPage = async () : Promise<void> => {
    if (addPageRef.current && props.newPageCallback) {
      const page = await addPageRef.current.getPage();

      if (page) {
        props.newPageCallback(page);
      }
    }
  };

  useImperativeHandle(ref, () => ({
    getPage
  }));

  const handleClose = () : void => {
    if (props.cancelCallback) {
      props.cancelCallback();
    }
  };

  const getPage = async () : Promise<AddUpdatePageCommand | null> => {
    if (addPageRef.current) {
      const page = await addPageRef.current.getPage();
      return page;
    }
    return null;
  };

  return (
    <>
      {!newPage && (
        <div className="text-center">
          <Button
            type="button"
            className="me-2"
            variant="outline-primary"
            onClick={cloneSamePage}>
            Clone to same page
          </Button>
          <Button
            type="button"
            variant="outline-primary"
            onClick={cloneNewPage}>
            Clone to new page
          </Button>
        </div>
      )}

      {newPage && (
        <>
          <div>
            <AddPageDialogue
              SelectedParent={null}
              DefaultLanguage={props.SourcePageLanguage ?? props.SourceVersion.Page?.Language ?? null}
              DisallowedAlias={props.SourcePageAlias ?? null}
              ref={addPageRef}
            />
          </div>
          <div>
            <hr />
          </div>
          <div className="mt-3 text-end">
            <Button variant="outline-success" className="me-2" onClick={handleCloneNewPage}>
              <FontAwesomeIcon icon={faSave} />&nbsp;Clone
            </Button>
            <Button variant="outline-primary" className="" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </>
  );
});

export default ClonePageDialogue;
